export default "__VITE_ASSET__81a2dd90__"